import { ReduceStore } from 'flux/utils';

import { ActionTypes } from 'constants/SettingConstants';
import { dispatcher } from 'lib/Dispatcher';

type ActionObject = {
  type: string;
  settings: string;
};

type GradesObject = {
  code: any;
  name: string;
};

type Props = {
  settings?: any;
};

type State = {
  settings?: any;
};

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class SettingsStore extends ReduceStore<Props, State> {
  getInitialState() {
    return {
      settings: null,
    };
  }

  isLoaded() {
    return this.getState().settings !== null;
  }

  getSetting(...names: string[]) {
    if (!this.isLoaded()) {
      return null;
    }

    let setting = this.getSettings();
    for (const name of names) {
      if (name in setting) {
        setting = setting[name];
      } else {
        break;
      }
    }
    return setting;
  }

  getSettings() {
    return this.getState().settings;
  }

  getLanguages() {
    return this.getSetting('languages');
  }

  getPrimaryLanguages(): { [code: string]: string } | null | undefined {
    return this.getSetting('languages', 'primary');
  }

  getPusherKey() {
    return this.getSetting('pusher', 'key');
  }

  getMinClassNameLength() {
    return this.getSetting('group', 'class_name', 'length', 'min');
  }

  getChatMembersLimit() {
    return this.getSetting('chats', 'members', 'limit');
  }

  getMaxClassNameLength() {
    return this.getSetting('group', 'class_name', 'length', 'max');
  }

  getMinClassCodeLength() {
    return this.getSetting('group', 'name', 'length', 'min');
  }

  getMaxClassCodeLength() {
    return this.getSetting('group', 'name', 'length', 'max');
  }

  getMessagesTiming() {
    return this.getSetting('messages', 'timing');
  }

  getMinimumOrgQueryLength() {
    return this.getSetting('organizations', 'minimum_name_query_length');
  }

  getGradeLevelForCode(code: string) {
    const grades = this.getSetting('grades');
    return grades && grades.find((g: GradesObject) => g.code === code);
  }

  getGradeLevelForName(name: string) {
    const grades = this.getSetting('grades');
    return grades && grades.find((g: GradesObject) => g.name === name);
  }

  getViewportTrackingMinTime() {
    return this.getSetting('tracking', 'viewport', 'min_time_ms');
  }

  reduce(state: State, action: ActionObject) {
    switch (action.type) {
      case ActionTypes.LOAD_SETTINGS:
        return { settings: action.settings };
      default:
        return state;
    }
  }
}

export default new SettingsStore(dispatcher);
